import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import Header from "../../../components/Header/Header";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import ProgressBar from "../../../components/ProgressBar";
import "./visualization.scss";
import AddIcon from "@mui/icons-material/Add";
import * as acts from "../../../redux/administrator/actions";

function validateLowerCase(input) {
  return input.toLowerCase();
}

function validateNoSpecialChars(input) {
  return input.replace(/[^a-zA-Z0-9_]/g, "");
}

function validateAndReplaceSpaces(input) {
  return input.replace(/\s+/g, "__");
}

const VisualizationHistoryTables = (props) => {
  const dispatch = useDispatch();
  const [vislizationBoxData, setVislizationBoxData] = useState([]);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const visualizationTableName = useSelector(
    (state) => state?.admin?.visualizationTableName
  );
  const visualizationBoxData = useSelector(
    (state) => state?.admin?.visualizationBoxData
  );

  const [selectValue, setSelectValue] = useState("");
  const [customInputValue, setCustomInputValue] = useState("");
  const [menuItems, setMenuItems] = useState([]);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [snackbar, setSnackbar] = useState(false);
  // const [loader, setLoader] = useState(false);
  // const [showNestedSelect, setShowNestedSelect] = useState(false);

  const [selectedFile, setSelectedFile] = useState({
    fileName: "",
    fileId: "",
  });
  const [selectedDropdownIndex, setSelectedDropdownIndex] = useState(-1);
  const [isChecked, setIsChecked] = useState(false);

  const handleSelectChange = (event, item) => {
    setSelectedDropdownIndex(item);
    const value = event.target.value;
    const updatedData = [...vislizationBoxData];
    updatedData[item].selectValue = value;
    setSelectValue(value);
    setVislizationBoxData(updatedData);
  };
  useEffect(() => {
    setVislizationBoxData(visualizationBoxData?.data);
  }, [visualizationBoxData?.data]);

  const handleCustomInputChange = (event) => {
    const inputValue = event.target.value;
    let validatedValue = validateLowerCase(inputValue);
    validatedValue = validateNoSpecialChars(validatedValue);
    validatedValue = validateAndReplaceSpaces(validatedValue);

    setCustomInputValue(validatedValue);
  };

  const handleSaveCustomValue = () => {
    if (customInputValue) {
      const newMenuItem = {
        value: customInputValue,
        label: customInputValue,
      };
      setMenuItems([...menuItems, newMenuItem]);
      setSelectValue(customInputValue);
      setCustomInputValue("");
      // setShowNestedSelect(false);
      const data = {
        table_name: customInputValue,
        created_by: localStorage?.userName,
        user_id: localStorage.userid,
      };
      dispatch(acts.addNewVisualizationTableName(data));
    }
  };
  useEffect(() => {
    dispatch(acts?.getVisualizationTableName());
    dispatch(acts?.getVisualizationBoxData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (visualizationTableName) {
      const tableName = visualizationTableName?.map((item) => ({
        value: item?.table_name,
        label: item?.table_name,
      }));
      setMenuItems((prevMenuItems) => [...tableName]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizationTableName]);
  useEffect(() => {
    //Success and error notification
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus.loader === false) {
        if (apiStatus?.next === true && apiStatus?.apiSuccess === true) {
          setSnackbar(true);
          setSeverity("success");
          setMessage(apiStatus?.message);
          // setLoader(false);

          setSelectedDropdownIndex(-1);
          setIsChecked(false);
          setVislizationBoxData([]);
          setMenuItems([]);
          dispatch(acts?.getVisualizationTableName());
          dispatch(acts?.getVisualizationBoxData());
          dispatch(acts?.clearApiStatus());
        } else if (
          apiStatus?.message !== null &&
          apiStatus?.message !== undefined &&
          apiStatus?.next === false &&
          apiStatus?.apiError === true
        ) {
          setMessage(apiStatus?.message);
          setSnackbar(true);
          setSeverity("error");
          // setLoader(false);
          dispatch(acts?.clearApiStatus());
          // dispatch(acts?.getVisualizationTableName());
          // dispatch(acts?.getVisualizationBoxData());
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  const handleChange = (e, index, id, item) => {
    setIsChecked((prevIsChecked) => !prevIsChecked);

    setSelectedFile({
      fileName: item?.name || "",
      fileId: item?.id || "",
    });
    if (isChecked === true) {
      setSelectedDropdownIndex(-1);
    }
  };

  const submit = () => {
    const data = {
      file_id: selectedFile.fileId,
      file_name: selectedFile.fileName,
      table_name: selectValue,
    };

    dispatch(acts.submitForVisualization(data));
  };

  return (
    <div>
      <Header />
      <Grid className="sidebar-main" container>
        <Grid item className="sidebar-container">
          <LeftSideBar page="sidebar" />
        </Grid>
        <Grid className="visualization-conatiner" item>
          <AdministratorHeader text="Import Visualization Data" />
          <div>
            <>
              <TableContainer className="visualization-history-container">
                <Table
                  stickyHeader
                  className="table-output"
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className="w-25" align="left">
                        Unit operation
                      </TableCell>
                      <TableCell align="center">File Name</TableCell>
                      <TableCell align="center">
                        Select For Visualization
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {vislizationBoxData?.map((item, index) => (
                      <TableRow key={item.id}>
                        <TableCell align="center">
                          <div>
                            {item?.selectValue !== "New" ? (
                              <FormControl fullWidth={true} className="w-100">
                                {item?.selectValue === "" ||
                                  (item?.selectValue === undefined && (
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      shrink={false}
                                    >
                                      Select or Enter Value
                                    </InputLabel>
                                  ))}
                                <Select
                                  value={item.selectValue}
                                  onChange={(event) =>
                                    handleSelectChange(event, index)
                                  }
                                  disabled={
                                    selectedDropdownIndex !== -1 &&
                                    selectedDropdownIndex !== index
                                  } // Disable based on selectedDropdownIndex
                                >
                                  <MenuItem value="New">New</MenuItem>
                                  {menuItems?.map((menuItem) => (
                                    <MenuItem
                                      key={menuItem.value}
                                      value={menuItem.value}
                                    >
                                      {menuItem.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            ) : (
                              <FormControl fullWidth={true} className="w-100%">
                                <OutlinedInput
                                  value={customInputValue}
                                  onChange={handleCustomInputChange}
                                  startAdornment={
                                    <Select
                                      disableUnderline
                                      variant="standard"
                                      value={item.selectValue}
                                      onChange={(event) =>
                                        handleSelectChange(event, index)
                                      }
                                      disabled={
                                        selectedDropdownIndex !== -1 &&
                                        selectedDropdownIndex !== index
                                      } // Disable based on selectedDropdownIndex
                                      className="w-70"
                                    >
                                      {menuItems.map((menuItem) => (
                                        <MenuItem
                                          key={menuItem.value}
                                          value={menuItem.value}
                                        >
                                          {menuItem.label}
                                        </MenuItem>
                                      ))}
                                      <MenuItem value="New">New</MenuItem>
                                    </Select>
                                  }
                                  endAdornment={
                                    <IconButton
                                      variant="outlined"
                                      onClick={() =>
                                        handleSaveCustomValue(index)
                                      }
                                    >
                                      <AddIcon />
                                    </IconButton>
                                  }
                                />
                              </FormControl>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="center">{item?.name}</TableCell>
                        <TableCell align="center">
                          {item?.status === true ? (
                            <Checkbox
                              checked={item?.status === true ? true : false}
                              disabled={
                                selectedDropdownIndex !== -1 &&
                                selectedDropdownIndex !== index
                              } // Disable based on selectedDropdownIndex
                              inputProps={{
                                "aria-label": "controlled",
                              }}
                            />
                          ) : (
                            <Checkbox
                              onChange={(e) =>
                                handleChange(e, index, item?.name, item)
                              }
                              disabled={
                                selectedDropdownIndex !== -1 &&
                                selectedDropdownIndex !== index
                              } // Disable based on selectedDropdownIndex
                              inputProps={{
                                "aria-label": "controlled",
                              }}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          </div>

          <Grid container>
            <Grid className="submit-btn-grid" item sm={12}>
              <Button
                className="submit-btn"
                onClick={submit}
                disabled={isChecked === false}
                variant="outlined"
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {snackbar && (
        <CustomizedSnackbars
          severity={severity}
          state={snackbar}
          text={message}
          handleClose={() => setSnackbar(false)}
        />
      )}
      {apiStatus?.loader === true && <ProgressBar />}
    </div>
  );
};
export default VisualizationHistoryTables;
